import { MapPin, Phone, Mail, Clock, Sparkles, AlertTriangle } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-14">
      <div className="text-xs uppercase tracking-widest text-labor-muted">Contattaci</div>
      <h1 className="font-display text-5xl mt-2 mb-8">Dove trovarci</h1>

      {/* AVVISO IMPORTANTE */}
      <div className="paper-card p-5 mb-8 border-l-4 border-l-labor-terracotta bg-red-50" data-testid="whatsapp-notice">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-6 h-6 text-labor-terracotta flex-shrink-0 mt-0.5" />
          <div>
            <div className="font-display text-lg text-labor-terracotta mb-1">Nuove modalità di contatto</div>
            <p className="text-sm text-labor-ink leading-relaxed">
              <strong>Il canale WhatsApp è stato disattivato</strong> per garantire un servizio più organizzato.
              Per <strong>informazioni</strong> usa <strong>Labor AI</strong> (in basso a destra) o prenota un <strong>appuntamento</strong> online.
              Il telefono è riservato <strong>alle sole urgenze reali</strong> negli orari di ufficio.
            </p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="space-y-5">
          <a href="https://www.google.com/maps/search/?api=1&query=Via+Zuavo+12+Bitonto+BA" target="_blank" rel="noopener" className="paper-card p-6 flex gap-4 items-start hover:border-b-labor-olive block">
            <MapPin className="w-6 h-6 text-labor-terracotta flex-shrink-0 mt-1" />
            <div>
              <div className="font-display text-xl">Indirizzo</div>
              <div className="text-labor-ink font-medium">Via Zuavo n. 12</div>
              <div className="text-labor-muted">70032 Bitonto (BA), Puglia</div>
              <div className="text-xs text-labor-olive mt-1">Apri in Google Maps →</div>
            </div>
          </a>
          <a href="tel:+393791466566" data-testid="contact-phone" className="paper-card p-6 flex gap-4 items-start hover:border-b-labor-olive block">
            <Phone className="w-6 h-6 text-labor-olive flex-shrink-0 mt-1" />
            <div>
              <div className="font-display text-xl">Telefono (solo urgenze)</div>
              <div className="text-labor-olive font-semibold text-lg">379 146 6566</div>
              <div className="text-labor-muted text-sm">Negli orari di ufficio · valutate personalmente da Vito</div>
            </div>
          </a>
          <div className="paper-card p-6 flex gap-4 items-start bg-labor-skyBg">
            <Sparkles className="w-6 h-6 text-labor-terracotta flex-shrink-0 mt-1" />
            <div>
              <div className="font-display text-xl">Labor AI</div>
              <div className="text-labor-muted text-sm mt-1">
                Il modo <strong>più veloce</strong> per avere info immediate. Disponibile 24/7 in basso a destra su ogni pagina. Registrati gratis per ricevere <strong>20 domande omaggio</strong>.
              </div>
            </div>
          </div>
          <div className="paper-card p-6 flex gap-4 items-start">
            <Mail className="w-6 h-6 text-labor-muted flex-shrink-0 mt-1" />
            <div>
              <div className="font-display text-xl">Email</div>
              <a href="mailto:caflaborvitobitonto@gmail.com" className="text-labor-muted hover:text-labor-olive break-all">caflaborvitobitonto@gmail.com</a>
            </div>
          </div>
        </div>
        <div className="paper-card p-6">
          <Clock className="w-6 h-6 text-labor-terracotta mb-3" />
          <div className="font-display text-2xl mb-4">Orari appuntamenti</div>
          <ul className="space-y-2 text-[15px]">
            <li className="flex justify-between border-b border-labor-border pb-2"><span className="font-medium">Lunedì</span><span>9:00-12:00 · 16:00-18:30</span></li>
            <li className="flex justify-between border-b border-labor-border pb-2"><span className="font-medium">Martedì</span><span>16:00-18:30</span></li>
            <li className="flex justify-between border-b border-labor-border pb-2"><span className="font-medium">Mercoledì</span><span>9:00-12:00 · <em className="text-labor-terracotta">Avv. 16:30-18:30</em></span></li>
            <li className="flex justify-between border-b border-labor-border pb-2"><span className="font-medium">Giovedì</span><span>16:00-18:30</span></li>
            <li className="flex justify-between border-b border-labor-border pb-2"><span className="font-medium">Venerdì</span><span>16:00-18:30</span></li>
            <li className="flex justify-between border-b border-labor-border pb-2 text-labor-muted"><span className="font-medium">Sabato</span><span>Chiuso</span></li>
            <li className="flex justify-between text-labor-muted"><span className="font-medium">Domenica</span><span>Chiuso</span></li>
          </ul>
          <div className="mt-5 p-3 bg-labor-skyBg text-sm text-labor-muted border-l-4 border-labor-olive">
            💡 Per prenotare un appuntamento usa il pulsante <strong>Prenota</strong> in alto, ti costa solo 30 secondi.
          </div>
        </div>
      </div>

      {/* MAPPA (link semplice) */}
      <div className="mt-10">
        <div className="text-xs uppercase tracking-widest text-labor-muted mb-3">Come raggiungerci</div>
        <a
          href="https://www.google.com/maps/search/?api=1&query=Via+Zuavo+12+Bitonto+BA"
          target="_blank"
          rel="noopener"
          data-testid="map-link"
          className="paper-card p-6 flex gap-4 items-center hover:border-b-labor-terracotta group"
        >
          <MapPin className="w-10 h-10 text-labor-terracotta flex-shrink-0" />
          <div className="flex-1">
            <div className="font-display text-2xl md:text-3xl underline decoration-labor-terracotta decoration-2 group-hover:decoration-4">VIA ZUAVO 12 · BITONTO</div>
            <div className="text-labor-muted text-sm mt-1">70032 Bitonto (BA), Puglia · Apri in Google Maps →</div>
          </div>
        </a>
      </div>
    </div>
  );
}
